// Questo codice è riferito dal campione di WebRTC.
// https://github.com/webrtc/samples/blob/gh-pages/src/content/peerconnection/trickle-ice/js/main.js

const servers = document.querySelector('select#servers') as HTMLSelectElement | null;
const urlInput = document.querySelector('input#url') as HTMLInputElement | null;
const usernameInput = document.querySelector('input#username') as HTMLInputElement | null;
const passwordInput = document.querySelector('input#password') as HTMLInputElement | null;

const allServersKey = 'servers';

interface IceServer {
  urls: string[];
  username?: string;
  credential?: string;
}

export function addServer(): void {
  if (!urlInput || !servers) return;

  const scheme = urlInput.value.split(':')[0];
  if (!['stun', 'stuns', 'turn', 'turns'].includes(scheme)) {
    alert(`URI scheme ${scheme} is not valid`);
    return;
  }

  // Memorizza il server ICE come oggetto JSON stringificato in option.value.
  const option = document.createElement('option');
  const iceServer: IceServer = {
    urls: [urlInput.value],
    username: usernameInput?.value,
    credential: passwordInput?.value
  };
  option.value = JSON.stringify(iceServer);
  option.text = `${urlInput.value} `;
  const username = usernameInput?.value;
  const password = passwordInput?.value;
  if (username || password) {
    option.text += ` [${username}:${password}]`;
  }
  option.ondblclick = selectServer;
  servers.add(option);
  if(usernameInput)
    usernameInput.value = '';
  if(passwordInput)
    passwordInput.value = '';
  urlInput.value = '';
  writeServersToLocalStorage();
}

export function removeServer(): void {
  if (!servers) return;

  for (let i = servers.options.length - 1; i >= 0; --i) {
    if (servers.options[i].selected) {
      servers.remove(i);
    }
  }
  writeServersToLocalStorage();
}

export function reset(): void {
  window.localStorage.clear();
  document.querySelectorAll('select#servers option').forEach(option => option.remove());
  const serversSelect = document.querySelector('select#servers') as HTMLSelectElement | null;
  if (serversSelect) {
    setDefaultServer(serversSelect);
  }
}

function selectServer(event: Event): void {
  if (!urlInput || !usernameInput || !passwordInput) return;

  const option = event.target as HTMLOptionElement;
  const value: IceServer = JSON.parse(option.value);
  urlInput.value = value.urls[0];
  usernameInput.value = value.username || '';
  passwordInput.value = value.credential || '';
}

function setDefaultServer(serversSelect: HTMLSelectElement): void {
  const option = document.createElement('option');
  option.value = '{"urls":["stun:stun.l.google.com:19302"]}';
  option.text = 'stun:stun.l.google.com:19302';
  option.ondblclick = selectServer;
  serversSelect.add(option);
}

function writeServersToLocalStorage(): void {
  const serversSelect = document.querySelector('select#servers') as HTMLSelectElement | null;
  if (!serversSelect) return;

  const allServers = JSON.stringify(
    Array.from(serversSelect.options).map(option => JSON.parse(option.value))
  );
  window.localStorage.setItem(allServersKey, allServers);
}

export function readServersFromLocalStorage(): void {
  document.querySelectorAll('select#servers option').forEach(option => option.remove());
  const serversSelect = document.querySelector('select#servers') as HTMLSelectElement | null;
  if (!serversSelect) return;

  const storedServers = window.localStorage.getItem(allServersKey);

  if (storedServers === null || storedServers === '') {
    setDefaultServer(serversSelect);
  } else {
    JSON.parse(storedServers).forEach((server: IceServer) => {
      const option = document.createElement('option');
      option.value = JSON.stringify(server);
      option.text = server.urls[0];
      option.ondblclick = selectServer;
      serversSelect.add(option);
    });
  }
}

export function getServers(): IceServer[] {
  const storedServers = window.localStorage.getItem(allServersKey);

  if (storedServers === null || storedServers === '') {
    return [{ urls: ['stun:stun.l.google.com:19302'] }, 
    // {urls: ['turn:turn.digitalemens.com:3478'], username: 'turn_digital', credential: 'Digital_2024!'}, 
    {urls: ['turn:turn.solveup.it:3478'], username: 'turnros', credential: 'RosTurn2020'}
  ];
  } else {
    return JSON.parse(storedServers);
  }
}
